import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import VoucherRefList from '../../account/voucher/components/VoucherRefList';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvSalesCollection = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)
        
    return (
        <div className="uiSingleColumn phViewContent">
            <div className="uiGridCol">
                <ul>
                    <li>
                        <div className="uiFlexDistributed">
                            <div className='uiFlexBox uiSpacerH5'>
                                <span className="uiLbl">
                                    <SarasTrans value="Payments" />
                                </span>
                                <span className="uiLblInLine uiSpacerH5">
                                    <SarasTrans value="Outstanding" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} className='uiSpacerH5 uiHighlightBlue' />
                                <span className="uiLblInLine uiSpacerH5">
                                    <SarasTrans value="Total Paid" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "payment" }} className='uiSpacerH5 uiHighlightBlue' />
                                <FormButton formObject={formObject} rowKey="" className="uiActionButton" text={<SarasTrans value="Collect Payment" />}
                                    action={{ actionId: "edit", paramName: "shVoucherLink",  
                                    actionParam: { collectpayment:"1", tdtId:"%dataList.valLDT" }, containerKey: "popup" }}
                                />
                            </div>
                        </div>
                        <div className="uiResetFloats">
                            <VoucherRefList viewData={formObject.childViews.voucherData} /> 
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default withView(InvSalesCollection, "invTrans", "invTrnHeader")